export const vars = {
    BaseURL: process.env.REACT_APP_BACKEND_URL,
    apiKey: process.env.REACT_APP_API_KEY
    
}

export const apiRoutes = {
    odoo:{
      getOrderData: vars.BaseURL + "/v1/odoo",
      getProductsByIds: vars.BaseURL + "/v1/odoo/by-odoo-ids",
      report: vars.BaseURL + "/v1/odoo-report"
    },
    prices: {
      getPricelists: vars.BaseURL + "/v1/product/price"
    },
    processMonitor: {
      base: vars.BaseURL + "/v1/process-monitor",
      getAllProcess: vars.BaseURL + "/v1/process-monitor/get-all",
    },
    cronjob: {
      status: vars.BaseURL + "/v1/cronjob/status",
    },
    cashea: {
      getCampaigns: vars.BaseURL + "/v1/cashea-campaign/",
      createCampaign: vars.BaseURL + "/v1/cashea-campaign/send-from-odoo-pricelist",
      sendProducts: vars.BaseURL + "/v1/cashea-prod/sendProducts",
      merchantsNames: vars.BaseURL + "/v1/merchants-name/merchantsName",
      refreshMerchantToken: vars.BaseURL + "/v1/merchants-name/merchantsName/refresh-token",
      syncMerchants: vars.BaseURL + "/v1/merchants-name/merchantsName/sync",
      getCategory: vars.BaseURL + "/v1/cashea-categories/",
      testOrderEndpoint: vars.BaseURL + "/v1/cashea-orders",
      getReport: vars.BaseURL + "/v1/report-cashea",
      pluginConfig: vars.BaseURL + "/v1/plugin-config",
      account: vars.BaseURL + "/v1/cashea-account",

    },
    tracking: {
      getTracking: vars.BaseURL + "/v1/track/get-tracking"
    },
    vtex: {
      acc: vars.BaseURL + "/v1/vtex-acc",
      products: vars.BaseURL + "/v1/vtex-prod",
      getWarehouses: vars.BaseURL + "/v1/vtex-warehouse",
      syncProducts: vars.BaseURL + "/v1/vtex-order",
      categories: vars.BaseURL + "/v1/vtex-categories",
      campaigns: vars.BaseURL + "/v1/vtex-campaign",
    },
    instapago: {
      acc: vars.BaseURL + "/v1/instapago-acc",
      pay: vars.BaseURL + "/v1/instapago-paylink",
      paymentInfo: vars.BaseURL + "/v1/instapago-bankInfo/get-payment/bank-info",
      banksAvailable: vars.BaseURL + "/v1/instapago-bankInfo/get-banks-available/bcv-bank-info",
      bankInfo: vars.BaseURL + "/v1/instapago-bankInfo"
    },
    debug: {
      getApiDebugById: vars.BaseURL + "/v1/api-debug",
      getCronDebugByCode: vars.BaseURL + "/v1/process-monitor/code",
      getNotificationProcess: vars.BaseURL + "/v1/notif-process",
      getProductLinkedLogs: vars.BaseURL + "/v1/h-products-linked"
    },
    falabella: {
      base: vars.BaseURL + "/v1/fala-campaigns",
      categories: vars.BaseURL + "/v1/fala-cat",
      products: vars.BaseURL + "/v1/fala-product"
    },
    ml: {
      base: vars.BaseURL + "/v1/ml-campaigns",
      categories: vars.BaseURL + "/v1/ml-cat",
      products: vars.BaseURL + "/v1/ml-product",
      sizeGrids: vars.BaseURL + "/v1/ml-product/get-all-size-grids",
      report: vars.BaseURL + "/v1/ml-report"
    },
    product: {
      base: vars.BaseURL + "/v1/product",
    },
    providers: {
      base: vars.BaseURL + "/v1/odoo-owner",
    },
    homeCenter: {
      acc: vars.BaseURL + "/v1/home-center-acc",
      products: vars.BaseURL + "/v1/home-center-products",
    },
    general: {
      getAvailablePlugins: vars.BaseURL + "/v1/main-plugin/available"
    }

  };
  
  export const pageRoutes = {
    main: "/",
    auth: "/admin",
  };